
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.19 2.5A4.696 4.696 0 0 0 2.5 7.19v6.12A4.696 4.696 0 0 0 7.19 18h6.12A4.696 4.696 0 0 0 18 13.31V7.19a4.696 4.696 0 0 0-4.69-4.69H7.19Zm7.139 2.855a.816.816 0 1 1 0 1.631.816.816 0 0 1 0-1.63Zm-4.079.816c2.25 0 4.079 1.83 4.079 4.079 0 2.25-1.83 4.079-4.079 4.079a4.084 4.084 0 0 1-4.079-4.079c0-2.25 1.83-4.079 4.079-4.079Zm0 1.224a2.855 2.855 0 1 0 0 5.71 2.855 2.855 0 0 0 0-5.71Z","fill":"#fff"}})])
          )
        }
      }
    